import React, {forwardRef, useImperativeHandle} from 'react'
import {connect} from "dva";
import moment from "moment";
import {DatePicker, Form, Input, Select} from "antd";


import {WizTableForm} from "@/containers/common";
import {modelUtils} from "@/utils";
import {useUpdateEffect} from "ahooks";


const userConfig = WizTableForm.Config.user(this, {apiParams: {state: 1}})
const userIdentityConfig = WizTableForm.Config.userIdentity(this, {apiParams: {state: 1}})
// const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
// const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})

const Index = (
  {
    refInstance: ref,
    dispatch,
    form,

    changeModal,
    record,

    editRes,
    learningScoreRecordLoading = false,
  }
) => {
  const {validateFields, getFieldDecorator, getFieldsValue, getFieldValue, setFieldsValue, resetFields} = form

  const action = !record ? 'add' : 'update'
  const {
    id,
    date,
    dataType,
    dataValue,
    personId,
    userName,
    fullName,
    orgId,
    orgName,
    positionId,
    positionName,
    source,
    remark,
  } = record || {}

  useImperativeHandle(ref, () => {
    const submit = () => {
      validateFields()
        .then(values => {
          const {date} = values || {}
          return {
            ...values,
            date: moment(date).format('YYYY-MM')
          }
        })
        .then((values) => {
          dispatch({
            type: `learningScoreRecord/${action}`,
            payload: {
              key: 'learningScoreRecord@edit',
              apiParams: {
                ...values,
                id: id,
              }
            }
          })
        })
        .catch((err) => {
          console.log('err', err)
        })
    }
    return {
      submit,
    }
  })

  useUpdateEffect(() => {
    const {success, msg, data} = editRes || {}
    if (!success) {
      wizNotice.error(msg);
      return;
    }
    wizNotice.success(msg)
    changeModal && changeModal(false, true)
  }, [editRes])

  const dataTypeElement = (
    <Form.Item label={'数据类型'}>
      {
        getFieldDecorator('dataType', {
          initialValue: dataType,
          rules: [
            {required: true, message: '请选择数据类型'},
          ],
        })(
          <Select
            disabled={!['add'].includes(action)}
            onChange={(e) => {
              setFieldsValue({
                personId: undefined,
                userName: undefined,
                fullName: undefined,
                orgId: undefined,
                orgName: undefined,
                positionId: undefined,
                positionName: undefined,
                dataValue: undefined,
              })
            }}
          >
            <Select.Option value={0}>业务积分</Select.Option>
            <Select.Option value={1}>业务状态</Select.Option>
          </Select>
        )
      }
    </Form.Item>
  )

  const dataType_form = getFieldValue('dataType')
  return (
    <Form labelCol={{span: 4}} wrapperCol={{span: 20}}>
      <Form.Item label={'年月'}>
        {
          getFieldDecorator('date', {
            initialValue: date && moment(date, 'YYYY-MM'),
            rules: [
              {required: true, message: '请选择年月'},
            ],
          })(
            <DatePicker.MonthPicker
              style={{width: '100%'}}
              format={'YYYY-MM'}
              disabled={!['add'].includes(action)}
            />
          )}
      </Form.Item>
      {dataTypeElement}
      <Form.Item label={'姓名'}>
        {
          getFieldDecorator('personId', {
            initialValue: personId,
            rules: [
              {required: true, message: '请选择姓名'},
            ],
          })(<span></span>)
        }
        <WizTableForm
          key={dataType_form}
          disabled={[undefined, undefined].includes(dataType_form) || !['add'].includes(action)}
          //{...(dataType_form === 0 ? userIdentityConfig : userConfig)}
          {...userIdentityConfig}
          rowName={'fullName'}
          selectType={'radio'}
          value={personId}
          initRows={personId ? [{
            id: personId,
            personId: personId,
            userName: userName,
            fullName: fullName,
            orgId: orgId,
            orgName: orgName,
            positionId: positionId,
            positionName: positionName
          }] : []}
          onChangeRowMap={(dataMap) => {
            const key = Object.keys(dataMap || {})?.[0]
            const {personId, userName, fullName, orgId, orgName, positionId, positionName} = dataMap?.[key] || {}
            setFieldsValue({
              personId: personId,
              userName: userName,
              fullName: fullName,
              orgId: orgId,
              orgName: orgName,
              positionId: positionId,
              positionName: positionName,
            })
          }}
        />
      </Form.Item>
      <Form.Item label={'账号'}>
        {
          getFieldDecorator('userName', {
            initialValue: userName,
            rules: [
              {required: true, message: '请选择账号'},
            ],
          })(<Text/>)
        }
      </Form.Item>
      {
        [0, 1].includes(dataType_form) ?
          <>
            {getFieldDecorator('orgName', {initialValue: orgName})}
            <Form.Item label={'组织'}>
              {
                getFieldDecorator('orgId', {
                  initialValue: orgId,
                  rules: [
                    {required: true, message: '请选择组织'},
                  ],
                })(<Text>{getFieldValue('orgName')}</Text>)}
            </Form.Item>
          </> : undefined
      }
      {
        dataType_form === 0 ?
          <>
            {getFieldDecorator('positionName', {initialValue: positionName})}
            <Form.Item label={'岗位'}>
              {
                getFieldDecorator('positionId', {
                  initialValue: positionId,
                  rules: [{required: true, message: '请选择岗位'}],
                })(<Text>{getFieldValue('positionName')}</Text>)
              }
            </Form.Item>
          </> : undefined
      }
      <Form.Item label={dataType_form !== 1 ? '积分' : '状态'}>
        {
          getFieldDecorator('dataValue', {
            initialValue: dataType_form !== 1 ? dataValue : dataValue > 0 ? 1 : 0,
            rules: [
              {required: true, message: dataType_form !== 1 ? '请输入积分' : '请选择状态'},
              {pattern: /^[0-9]+$/, message: "只允许出现数字"},
              {pattern: /^.{0,10}$/, message: "最多10个字符"},
            ],
          })(
            dataType_form !== 1 ?
              <Input/> :
              <Select>
                <Select.Option value={1}>合格</Select.Option>
                <Select.Option value={0}>不合格</Select.Option>
              </Select>
          )
        }
      </Form.Item>
      <Form.Item label={'数据来源'}>
        {
          getFieldDecorator('source', {
            initialValue: source,
            rules: [
              {max: 50, message: '数据来源最多50个字符'}
            ],
          })(<Input placeholder={'请填写数据来源'}/>)
        }
      </Form.Item>
      <Form.Item label={'备注'}>
        {
          getFieldDecorator('remark', {
            initialValue: remark,
            rules: [
              {max: 200, message: '备注最多200个字符'}
            ],
          })(<Input placeholder={'请填写备注'}/>)
        }
      </Form.Item>
    </Form>
  )
}

const Text = ({value: text, children}) => <div>{children || text}&nbsp;</div>


const mapStateToProps = (state, ownProps) => {
  const {learningScoreRecord} = state

  const editRes = modelUtils.getModelEntity(learningScoreRecord, 'learningScoreRecord@edit');
  const load = modelUtils.getLoadingState(state, ['learningScoreRecord']);

  return {
    editRes,
    ...load,
  }
};

const Tc = connect(mapStateToProps, null, null, {forwardRef: true})(Index)
export default Form.create()(forwardRef((props, ref) => <Tc {...props} refInstance={ref}/>))
